export default __webpack_public_path__ + "static/media/010-barbed-wire.73f97917.png";